import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import FreeBooks from '@/components/screens/free-books/FreeBooks';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBookPage } from '@/interfaces/booksPage.interface';

interface IFreeBooksPage {
  books: IBookPage;
}

const FreeBooksPage: NextPage<IFreeBooksPage> = ({ books }) => {
  return <FreeBooks books={books} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch(`${API_URL}satellite/books?free_book=true&page=1&page_size=${BOOKS_FOR_PAGE}&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default FreeBooksPage;
